/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Location: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M18.352 16.5391C17.89 17.1741 17.423 17.7761 16.965 18.3341C19.933 18.7631 21.711 19.5091 21.986 19.9991C21.582 20.7211 17.925 21.9991 12 21.9991C5.957 21.9991 2.273 20.6691 1.994 20.0411C2.185 19.5521 3.978 18.7741 7.033 18.3331C6.576 17.7751 6.109 17.1731 5.647 16.5381C2.601 17.0951 0 18.1471 0 20.0001C0 23.1581 7.543 24.0001 12 24.0001C16.457 24.0001 24 23.1581 24 20.0001C24 18.1471 21.399 17.0951 18.352 16.5391Z'
      fill='currentColor'
    />
    <path
      d='M12 0C8.067 0 4 2.992 4 8C4 12.6 10.544 19.327 11.29 20.08C11.478 20.269 11.733 20.375 12 20.375C12.267 20.375 12.522 20.269 12.71 20.08C13.456 19.327 20 12.6 20 8C20 2.992 15.933 0 12 0ZM12 10C10.895 10 10 9.105 10 8C10 6.895 10.895 6 12 6C13.105 6 14 6.895 14 8C14 9.105 13.105 10 12 10Z'
      fill='currentColor'
    />
  </React.Fragment>
)
